import { useViewport } from 'hooks/3catinfo/useViewport';
import { getPreposition } from '@portal-internet/core';
import Icona from 'components/3catinfo/ui/Icona';
import Boto from 'components/3catinfo/Boto';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './titol.module.scss';

export default function Titol(props) {
    const {
        titol,
        prefix,
        sufix,
        prefixSubtitol,
        subtitol,
        sufixSubtitol,
        afegirPreposicioTitol,
        preposicio,
        tipus,
        tag,
        className,
        sliderId,
        icona,
        iconaTitol,
        text,
        estil,
        estilTitolMes,
        estilBoto,
        isIconaBlanc,
        tema,
        link,
        linkTipus,
        slug,
        slug2,
        mostrarBotoMesItems,
        fons,
        ariaLabel,
        dataTestId,
        idDom
    } = props;

    const { zoomNavigator } = useViewport();
    const route = {
        href: link,
        type: linkTipus,
        slug: slug,
        slug2: slug2
    };

    let Tag = tag;

    if (__isEmpty(Tag)) {
        if (tipus === 'seccio') {
            Tag = 'h2';
        } else {
            Tag = 'h1';
        }
    }

    const _netejaTitolTira = () => {
        if (!titol) return titol;
        let titolPrint = titol.replace(/\*\[([^\][]*)]\*/g, '').trim();
        titolPrint = afegirPreposicioTitol ? `${getPreposition(titolPrint, preposicio)}${titolPrint}` : titolPrint;
        return `${prefix || ''}${titolPrint}${sufix || ''}`;
    };

    const styleTitol = clsx({
        [styles.titol]: true,
        [styles[tipus]]: !__isEmpty(tipus),
        [styles[estil]]: !__isEmpty(estil),
        [styles.ambZoom]: zoomNavigator > 2,
        [[className]]: !__isEmpty(className)
    });

    const styleTitolMes = clsx({
        [styles.titolMesWrapper]: true,
        [styles[tipus]]: !__isEmpty(tipus),
        [styles.titolMes]: mostrarBotoMesItems,
        [styles[estilTitolMes]]: !__isEmpty(estilTitolMes),
        [styles[fons]]: !!fons
    });

    const styleTitolMesLink = clsx({
        [styles.titolMes_link]: true,
        [styles.titolMes_link_pr0]: estilTitolMes !== 'boto-ple'
    });

    const styleIconaTitol = clsx({
        [styles[iconaTitol?.estil]]: !__isEmpty(iconaTitol?.estil),
        [styles.contentIconaTitol]: true
    });

    if (mostrarBotoMesItems) {
        return (
            <div className={styleTitolMes}>
                <div className={styles.titolWrapper}>
                    {titol && (
                        <Tag className={styleTitol} {...(slug && Tag === 'h2' ? { 'data-testid': slug } : {})}>
                            {_netejaTitolTira()}
                        </Tag>
                    )}
                    {subtitol && (
                        <span className={styles.subtitol}>{`${prefixSubtitol || ''}${subtitol}${sufixSubtitol || ''}`}</span>
                    )}
                </div>
                <span className={styles.titolMes_tot}>
                    <Boto
                        novaFinestra={false}
                        route={route}
                        text={text}
                        ariaLabel={ariaLabel}
                        estil={estilBoto ?? 'transparent'}
                        className={styleTitolMesLink}
                        tema={tema}
                        icona={icona}
                        isIconaBlanc={estilTitolMes === 'blanc' ? true : isIconaBlanc}
                        fons={fons}
                        iconaInline={true}
                        dataTestId={dataTestId}
                    />
                </span>
            </div>
        );
    }

    if (sliderId) {
        return (
            <Tag className={styleTitol} id={sliderId}>
                {_netejaTitolTira()}
            </Tag>
        );
    }

    if (iconaTitol?.icona) {
        return (
            <div className={styleIconaTitol}>
                <span className={styles.iconaTitol} data-testid={`icona-${iconaTitol.icona}`}>
                    <Icona icona={iconaTitol.icona} alt={iconaTitol.icona} mida={iconaTitol.mida ?? 40} />
                </span>
                <Tag className={styleTitol}>{_netejaTitolTira()}</Tag>
            </div>
        );
    }

    return (
        <Tag className={styleTitol} data-testid={dataTestId} {...(idDom && { id: idDom })}>
            {_netejaTitolTira()}
        </Tag>
    );
}
